import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import fr from "./locales/fr.json";

void i18n.use(initReactI18next).init({
  lng: "fr",
  fallbackLng: "fr",
  resources: {
    fr: { translation: fr },
  },
  interpolation: {
    escapeValue: false,
  },
});

export { i18n };

